<template>
    <div>
      <div class="a-ui-tab__block">
        <template v-for="(criterion, idx) in priceCriteria">
          <div class="a-ui-tab__control-panel">
            <div class="a-ui-tab__control">
              <div class="a-ui-tab__arrow"></div>
              <div class="a-ui-tab__number-block">{{idx + 1}}</div>
              <div class="a-ui-tab__title">
                <img class="table-tab__img-help"
                     src="@/assets/img/static/warning.svg"
                     v-if="wasCriterionChangedByParticipant(criterion)">
                {{criterion.criterionName}}
                <span v-if="lot.showWeight">
                  ({{$t('form.lot.weight-of-criterion-in-final-estimation')}} {{criterion.weight}}%)
                </span>
              </div>
            </div>
            <div class="a-ui-tab__content" v-if="lot.permissions.CAN_SEE_PUBLIC_LOT_CHANGE_REQUEST && criterion.permissions.CAN_ADJUST_CRITERIA">
              <div class="a-ui-tab__file-flex-block">
                <div class="a-ui-tab__file-item-right a-width-100-percent">
                  <button class="gui-btn gui-btn--red "
                          @click.prevent="onAllowCriterionUpdateClick({ criterionId: criterion.num, bid: bid.num })">{{$t('buttons.grant-participant-editing')}}</button>
                </div>
              </div>
            </div>
          </div>

          <div class="a-container-form" v-if="criterion.till">
              <span class="a-width-100-percent a-color-red">
                Редактирование разрешено до <date-time tag="i" :value="criterion.till"></date-time>
                <div class="u-color-black a-formatted-text">{{criterion.tillDescription}}</div>
              </span>
          </div>
        </template>

        <div class="a-ui-tab__content-block" v-if="editable">
          <div class="a-container-form">
            <div class="a-label a-label--w-280">{{$t('form.lot.current-price')}}: </div>
            <div class="a-form-field a-width-100-percent">
              <bid-payments-pivot-table :bid="bid" show-always :with-taxes="lot.withTaxes"></bid-payments-pivot-table>
<!--            <p>{{price | price}} ({{lot.withTaxes ? $t('form.lot.with-taxes') : $t('form.lot.without-taxes')}})</p>-->
              <span class="a-validation-error position-relative" v-if="bid.isTooHigh">
                Сумма предложения превышает начальную цену лота {{lot.initialPrice | price}} {{$t(lot.currency.label)}}
              </span>
            </div>
          </div>
          <div class="a-container-form" v-if="bid.priceInRequest.length">
            <div class="a-label a-label--w-280">{{$t('form.lot.current-price-in-request')}}:</div>
            <div class="a-form-field a-width-100-percent">
              <total-in-bid :total="bid.priceInRequest" :with-taxes="lot.withTaxes"></total-in-bid>
            </div>
          </div>

          <div class="a-container-form" v-if="bid.till">
              <span class="a-width-100-percent a-color-red">
                Редактирование основных ценовых критериев разрешено до <date-time tag="i" :value="bid.till"></date-time>
                <div class="u-color-black a-formatted-text">{{bid.tillDescription}}</div>
              </span>
          </div>

          <div class="a-container-form align-items-baseline">
            <div class="a-label a-label--w-280">{{$t('form.lot.bid-validy-period')}}:</div>
            <div class="a-flex-start align-items-baseline a-spaces-between">
              <div class="a-form-field a-input--w-80"
                   :class="{ 'a-input-group--error': $v.bid.duration.$invalid }"
                   v-if="bid.permissions.CAN_EDIT_BID">
                <input class="a-input"
                       v-model="bid.duration"
                       @change="saveForm()">
                <span class="position-relative a-validation-error"
                      v-if="!$v.bid.duration.valid">
                        Не может быть меньше 90 дней
                </span>
              </div>
              <p v-else>{{bid.duration}}</p>
              <p>{{$t('form.lot.calendar-days-with-short')}}</p>
            </div>
          </div>
        </div>
      </div>

      <approve-changes-dialog ref="approveChanges"
                              :lot="lot"
                              :bid="bid"
                              section="Дополнительные ценовые критерии"
      ></approve-changes-dialog>
    </div>
</template>

<script>
  import { required } from '@/validators'
  import Currency from '@/api/types/currency'
  import CommonMixins from '../mixins/common'
  import BidPaymentsPivotTable from "./BidPaymentsPivotTable";
  import ApproveChangesDialog from "../../../common/dialogs/ApproveChangesDialog";
  import TotalInBid from "./TotalInBid";

  export default {
    components: {TotalInBid, ApproveChangesDialog, BidPaymentsPivotTable},
    props: {
      lot: Object,
      bid: Object
    },

    mixins: [
      CommonMixins
    ],

    computed: {
      priceCriteria() {
        return this.bid.criteria.price;
      },

      editable() {
        return !!this.lot.request.permissions.HAS_ACCREDITATION;
      },

      price() {
        return this.bid.specs.reduce((sum, e) => sum + e.price * e.count, 0);
      }
    },

    validations: {
      bid: {
        duration: {
          required,
          valid(value) {
            return value >= 90;
          }
        }
      }
    },

    methods: {
      wasCriterionChangedByParticipant(criterion) {
        return !!_.find(this.lot.request.userChangesHistory, {
          bidNum: this.bid.num,
          criterion: criterion.num
        });
      },

      onAllowCriterionUpdateClick(options) {
        this.$refs.approveChanges.open({
          onConfirm: async (info) => {
            await this.onAllowCriterionUpdate(options, info);
          }
        })
      },

      async onAllowCriterionUpdate(options, adjustInfo) {
        this.runBlockerAction(async () => {
          try {
            await this.$store.dispatch('allowCriterionUpdate', {
              lotId: this.lot.id,
              requestId: this.lot.request.id,
              criterionId: options.criterionId,
              bid: options.bid,
              description: adjustInfo.description,
              till: adjustInfo.till
            });
          }
          catch(e) {
            console.error('failed allowing document update', e);
            this.globalErrorHandler(e);
          }
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  .a-spaces-between {
    > * {
      margin-right: 10px;
    }

    > p {
      font-size: 17px;
      line-height: 17px;
    }
  }
</style>
